import { Dropzone } from '@grupoa/editor-html';
import { format, parseISO } from 'date-fns';
import { VRuntimeShell } from '@grupoa/components';

const DEFAULT_LOCALE_DATE_FORMAT = 'dd/MM/yyyy HH:mm';

export default {
  components: {
    Dropzone,
    VRuntimeShell
  },
  props    : ['content', 'title'],
  computed : {
    computedDateTime() {
      if (!this.content.expectedAnswerAt) {
        return '';
      }

      let date = this.content.expectedAnswerAt;
      if (typeof date === 'string' || this.content.expectedAnswerAt instanceof String) {
        date = parseISO(this.content.expectedAnswerAt);
      }

      return format(date, DEFAULT_LOCALE_DATE_FORMAT);
    }
  }
};
